// 初始化字号
window.onload = function(){
	chushihuazihao();
}
window.onresize = function(){
	chushihuazihao();
}
function chushihuazihao(){
	var deviceWidth = document.documentElement.clientWidth;
	if(deviceWidth > 750) deviceWidth = 750;
	if(deviceWidth < 320) deviceWidth = 320;
	document.documentElement.style.fontSize = deviceWidth / 15 + 'px';
}


// WEBPACK FOOTER //
// ./src/assets/js/font.js